import { useEffect } from 'react';

/** Only missing pages receive noindex; temporary API failures remain retryable. */
export function useRobots(content?: string) {
  useEffect(() => {
    let meta = document.head.querySelector('meta[name="robots"]');
    if (!content) { meta?.remove(); return; }
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
    return () => { meta?.remove(); };
  }, [content]);
}
